/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Automatic_Save_Restore_Point_CreatedInputs */

const en_automatic_save_restore_point_created = /** @type {(inputs: Automatic_Save_Restore_Point_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Restore point created successfully`)
};

const fr_automatic_save_restore_point_created = /** @type {(inputs: Automatic_Save_Restore_Point_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Point de restauration créé avec succès`)
};

const de_automatic_save_restore_point_created = /** @type {(inputs: Automatic_Save_Restore_Point_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wiederherstellungspunkt erfolgreich erstellt`)
};

const it_automatic_save_restore_point_created = /** @type {(inputs: Automatic_Save_Restore_Point_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Punto di ripristino creato correttamente`)
};

const ru_automatic_save_restore_point_created = /** @type {(inputs: Automatic_Save_Restore_Point_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Точка восстановления успешно создана.`)
};

const es_automatic_save_restore_point_created = /** @type {(inputs: Automatic_Save_Restore_Point_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Punto de restauración creado exitosamente`)
};

const zh_cn2_automatic_save_restore_point_created = /** @type {(inputs: Automatic_Save_Restore_Point_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`还原点创建成功`)
};

const ja_automatic_save_restore_point_created = /** @type {(inputs: Automatic_Save_Restore_Point_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`復元ポイントが正常に作成されました`)
};

const hi_automatic_save_restore_point_created = /** @type {(inputs: Automatic_Save_Restore_Point_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`पुनर्स्थापना बिंदु सफलतापूर्वक बनाया गया`)
};

const pt_pt2_automatic_save_restore_point_created = /** @type {(inputs: Automatic_Save_Restore_Point_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ponto de restauração criado com sucesso`)
};

/**
* | output |
* | --- |
* | "Restore point created successfully" |
*
* @param {Automatic_Save_Restore_Point_CreatedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const automatic_save_restore_point_created = /** @type {((inputs?: Automatic_Save_Restore_Point_CreatedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Automatic_Save_Restore_Point_CreatedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_automatic_save_restore_point_created(inputs)
	if (locale === "de") return de_automatic_save_restore_point_created(inputs)
	if (locale === "it") return it_automatic_save_restore_point_created(inputs)
	if (locale === "ru") return ru_automatic_save_restore_point_created(inputs)
	if (locale === "es") return es_automatic_save_restore_point_created(inputs)
	if (locale === "zh-CN") return zh_cn2_automatic_save_restore_point_created(inputs)
	if (locale === "ja") return ja_automatic_save_restore_point_created(inputs)
	if (locale === "hi") return hi_automatic_save_restore_point_created(inputs)
	if (locale === "pt-PT") return pt_pt2_automatic_save_restore_point_created(inputs)
	return en_automatic_save_restore_point_created(inputs)
});